import React from 'react';
import createSVG from './createSVG';

const LiteraturIcon = ({style}) => (
  <path style={style} d="M1,21.475 L24.5,21.475 L24.5,5.025 L1,5.025 L1,21.475 Z M12.749,25 L12.749,1.5 L12.749,25 Z" stroke="#7D7D7D" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
);

export default createSVG(LiteraturIcon);
